export default __webpack_public_path__ + "static/media/mc-qr-apple.bdf16395.png";